export default __webpack_public_path__ + "static/media/DaveMarble.5f255d13.png";